import { useCallback, useEffect, useState } from "react";
import { useGetClients } from "../../interfaces/clients";
import CommonDataGrid from "../common/CommonDataGrid";
import { Button, Checkbox, FormControl, FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { useQueryClient } from "react-query";
import { CommonGridBox, CommonMainWrap, CommonSubBox } from "../../styles/common";
import Detail from "./Detail";
import { formatBizNo } from "../../common/util";
import moment from "moment";

const columns = [
    { field: 'cname', headerName: '업체명', width: 200, headerAlign:'center' },
    { field: 'alias', headerName: '업체명(별칭)', width: 200, headerAlign:'center' },
    { field: 'biz_no', headerName: '사업자번호', width: 120, headerAlign:'center', align:'center' },
    { field: 'owner_nm', headerName: '대표명', width: 150, headerAlign:'center', align:'center' },
    { field: 'email', headerName: 'Email', width: 200, headerAlign:'center', },
    { field: 'fax_no', headerName: 'FAX', width: 100, headerAlign:'center' },
    { field: 'clientId', headerName: '아이디', width: 150, headerAlign:'center' },
    { field: 'pass', headerName: '패스워드', width: 120, headerAlign:'center', align:'center' },
    { field: 'dir_nm', headerName: '폴더명', width: 120, headerAlign:'center', align:'center' },
    { field: 'vol_nm', headerName: '볼륨명', width: 120, headerAlign:'center', align:'center' },
]

const Client = () => {

    const queryClient = useQueryClient();

    const {data: list, isLoading} = useGetClients();

    const [clientList, setClientList] = useState([]);

    const [searchAlias, setSearchAlias] = useState();
    const [searchBizNo, setSearchBizNo] = useState();
    const [searchRegId, setSearchRegId] = useState();

    const [detail, setDetail] = useState(undefined);

    useEffect(()=>{
        if(list){
            const aliasFilter = searchAlias ? list.filter((item)=> item.alias.indexOf(searchAlias) > -1) : list;
            const bizNoFilter = searchBizNo ? aliasFilter.filter((item)=> item.biz_no.indexOf(searchBizNo.replaceAll('-','')) > -1) : aliasFilter;
            const regIdFilter = searchRegId ? bizNoFilter.filter((item)=> (item.is_cre+'') === searchRegId) : bizNoFilter;

            setClientList(regIdFilter.map((item,index)=>({
                                    ...item,
                                    biz_no: formatBizNo(item.biz_no),
                                    vol_nm: (item.vol_nm && item.vol_nm.length>0) ? item.vol_nm : '미배정',
                                    id:index
                                })));
        }else{
            setClientList([])
        }
    },[list, searchAlias, searchBizNo, searchRegId])

    return (
        <CommonMainWrap>
            <CommonSubBox style={{justifyContent:'space-between'}}>
                <div style={{display:'flex',alignItems:'start',gap:'8px'}}>
                    <TextField
                            id='alias'
                            label='업체명'
                            size='small'
                            value={searchAlias}
                            onChange={(e)=>setSearchAlias(e.target.value)}
                        />
                    <TextField
                            id='biz_no'
                            label='사업자번호'
                            size='small'
                            value={searchBizNo}
                            onChange={(e)=>setSearchBizNo(formatBizNo(e.target.value.replaceAll('-','')))}
                        />
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="is_ing-label"
                            defaultValue={''}
                            name="is_ing"
                            onChange={(e)=>setSearchRegId(e.target.value)}
                        >
                            <FormControlLabel value={''} control={<Radio />} label={`전체 (${list && list.length})`} />
                            <FormControlLabel value={1} control={<Radio />} label={`계정 발급완료 (${list && list.filter((item)=>item.is_cre===1).length})`} />
                            <FormControlLabel value={0} control={<Radio />} label={`계정 미발급 (${list && list.filter((item)=>item.is_cre===0).length})`} />
                            <FormControlLabel value={2} control={<Radio />} label={`신청중 (${list && list.filter((item)=>item.is_cre===2).length})`} />
                        </RadioGroup>
                    </FormControl>
                </div>
                <Button variant="contained" onClick={()=>setDetail({})}>고객사 추가</Button>
            </CommonSubBox>
            <div style={{textAlign:'right',fontSize:'0.8rem'}}>
                {queryClient.getQueryData(['REFRESH_TIME'])?
                    moment(queryClient.getQueryData(['REFRESH_TIME']).time).format('yyyy/MM/DD HH:mm:ss')
                    : ''
                }
            </div>
            <CommonGridBox>
                <CommonDataGrid
                        isLoading={isLoading}
                        list={clientList}
                        columns={columns}
                        onRowClick={(e)=>setDetail(e.row)}
                        hideFooterRowCount={true}
                        />
            </CommonGridBox>
            {detail && <Detail target={detail} close={setDetail}/>}
        </CommonMainWrap>
    );

}

export default Client;